import { Component, OnInit, Input } from '@angular/core';
import { OmsServiceService } from '../../services/oms-service.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormControl, FormsModule, Validators, FormBuilder } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-track-order',
  templateUrl: './track-order.component.html',
  styleUrls: ['./track-order.component.scss']
})
export class TrackOrderComponent implements OnInit {

  @Input() order_id;
  @Input() odid;
  @Input() order_receipt;
  @Input() refund_id;
  @Input() amount;
  @Input() status;

  isReceiptBillView: boolean = false;
  isProcessRefundOrderView: boolean = false;
  isOrderTrackStatusView: boolean = false;
  isRefundRejectedView: boolean = false;
  isInstantRefundEnable: boolean = false;
  refundAmount: string = null;
  processForm: FormGroup;
  RejectForm: FormGroup;
  orderLogData :[];
  receiptLogData :[];
  paymentRefNo: string = null;
  paymentMode: any = null;
  constructor(

    private omsService :OmsServiceService,
    public modal: NgbActiveModal,
    private toastr: ToastrService
  ) { 
    this.processForm = new FormGroup({
      paymentType: new FormControl(),
      refundAmount: new FormControl(),
      transcactionCode: new FormControl(),
    });
    this.RejectForm = new FormGroup({
      sub_category: new FormControl(),
      sub_category_description: new FormControl(),
    });
   }

  ngOnInit(): void {

    if(this.order_receipt == 'receipt_details'){      
      this.isReceiptBillView = true;
      this.getReceiptData(this.order_id);
    }else if(this.order_receipt == 'processing_refundOrder'){
      this.processForm.patchValue({
        refundAmount:this.amount,
      })
      this.isProcessRefundOrderView = true;
      this.getReceiptData(this.order_id)
    }else if(this.order_receipt == 'refund_rejected'){
      this.isRefundRejectedView = true;
      this.getCategorySubCataegory();
    }else{
      this.isOrderTrackStatusView = true;
      this.getOrderData(this.order_id);
    }

  }


  getOrderData(orderId)
  {

    let orderTrackRequest = {};
    orderTrackRequest["order_id"] = orderId;
    orderTrackRequest["isInternalCall"] = 1;
    orderTrackRequest["action"] = "OMS/api/operation.php/v1/ordertrack";
    orderTrackRequest["type"] = "post";
    this.omsService.getOrderTrackData(orderTrackRequest).subscribe(
      (res) => {
        //console.log(res);
        if (res["status"] == 1) {
        this.orderLogData =  res["data"].order_log;
 
         //console.log(this.orderLogData);
        } 

      }
    )
    
  }

  getReceiptData(orderId)
  {

    let orderTrackRequest = {};
    orderTrackRequest["order_id"] = orderId;
    orderTrackRequest["isInternalCall"] = 1;
    orderTrackRequest["action"] = "OMS/api/operation.php/v1/BillInfo";
    orderTrackRequest["type"] = "post";
    this.omsService.getReceiptOrderData(orderTrackRequest).subscribe(
      (res) => {
        console.log(`getReceiptOrderData`,res);
        if (res["status"] == 1) {
          this.receiptLogData =  res["data"].advance_receipt;

          this.paymentRefNo =  res["data"].advance_receipt[0].payment_ref_no;
          this.paymentMode =  res["data"].advance_receipt[0].payment_mode;
          if(this.paymentMode == 17 && (this.paymentRefNo != null || this.paymentRefNo != '')){
              this.isInstantRefundEnable = true;
              this.processForm.patchValue({
                paymentType:'instantrefund',
              })
          }
         //console.log(this.orderLogData);
        } 

      }
    )
    
  }

  process_refund_order()
  {
    let selectedPaymentType = this.processForm.get('paymentType').value;
    let selectedRefundAmount = this.processForm.get('refundAmount').value;
    let selectedTranscactionCode = this.processForm.get('transcactionCode').value;

      if (this.processForm.get("paymentType").value != null && this.processForm.get("paymentType").value != undefined) {
          if (this.processForm.get("refundAmount").value != null && this.processForm.get("refundAmount").value != undefined) {
                if (this.processForm.get("transcactionCode").value != null && this.processForm.get("transcactionCode").value != undefined) {

    if(this.processForm.get("paymentType").value == 'instantrefund'){
        if (this.processForm.get("refundAmount").value <= this.amount) {
              let requestInstantRefund = {};
              requestInstantRefund["order_id"] = this.order_id;
              requestInstantRefund["order_did"] = this.odid;
              requestInstantRefund["amount"] = +selectedRefundAmount;
              requestInstantRefund["source_type"] = 'SDM';
              requestInstantRefund["remarks"] = selectedTranscactionCode;
              requestInstantRefund["refund_initiate_by"] = window.localStorage.getItem('actionById');
              requestInstantRefund["refund_initiate_by_name"] = window.localStorage.getItem('actionByName');
              requestInstantRefund["action"] = 'OMS/api/operation.php/v4/refund/to/source';
              requestInstantRefund["type"] = 'post';

              console.log(`requestInstantRefund`, requestInstantRefund);
                this.omsService.instantRefundOrder(requestInstantRefund).subscribe(
                (res) => {
                     console.log(`InstantRefundRes`, res);
                      if (res["status"] == 1) {
                        this.toastr.success('Refund Intiateed Successfullay...!');
                          // setTimeout(function(){                          
                          //     window.location.reload();
                          // }, 2000);
                          this.updateRefundStatus();
                      } 
                })
        }else{
          this.toastr.error('Please enter refund amount less than or equal value');
        }
    }else{

          this.updateRefundStatus();
    }
                }else{
                  this.toastr.error('Please enter transcaction code or remarks');
                }
            }else{
            this.toastr.error('Please enter refund amount');
            }
          }else{
          this.toastr.error('Please select payment type');
          }
  }

  updateRefundStatus()
  {

              let requestData = {};
              requestData["refund_id"] = this.refund_id;
              requestData["order_id"] = this.order_id;
              requestData["status"] = this.status;
              requestData["transaction_type"] = this.processForm.get("paymentType").value;
              requestData["transaction_code"] = this.processForm.get("transcactionCode").value;
              requestData["amount"] = this.processForm.get("refundAmount").value;
              requestData["reason"] = '';
              requestData["user_id"] = window.localStorage.getItem('actionById');
              requestData["username"] = window.localStorage.getItem('actionByName');
              requestData["isInternalCall"] = 1;
              requestData["action"] = 'OMS/api/operation.php/v1/update/refund/info';
              requestData["type"] = 'post';

              console.log(`refundRequestData`, requestData);
                this.omsService.updateRefundOrder(requestData).subscribe(
                (res) => {
                     console.log(`updateRefundOrder`, res);
                      if (res["status"] == 1) {
                        this.toastr.success(res["message"]);
                          setTimeout(function(){                          
                              window.location.reload();
                          }, 2000);
                      } 
                })
  }

  refund_reject()
  {
    let sub_category = this.RejectForm.get('sub_category').value;
    let sub_category_description = this.RejectForm.get('sub_category_description').value;
    
      if (this.RejectForm.get("sub_category").value != null && this.RejectForm.get("sub_category").value != undefined) {
          if (this.RejectForm.get("sub_category_description").value != null && this.RejectForm.get("sub_category_description").value != undefined) {

              let requestData = {};
              requestData["order_id"] = this.order_id;
              requestData["category"] = 'Refund';
              requestData["sub_category"] = sub_category;
              requestData["sub_category_description"] = sub_category_description;
              requestData["isInternalCall"] = 1;
              requestData["action"] = 'OMS/api/operation.php/v1/generateTicket';
              requestData["type"] = 'post';

              console.log(`refundRequestData`, requestData);
                this.omsService.rejectRefundOrder(requestData).subscribe(
                (res) => {
                     console.log(`rejectRefundOrder`, res);
                      if (res["Result"] == "Success") {
                        this.toastr.success(res["Status"]);
                          setTimeout(function(){                          
                              window.location.reload();
                          }, 2000);
                      } 
                }) 
            }else{
            this.toastr.error('Please enter description');
            }
          }else{
          this.toastr.error('Please select reason');
          }    
  }

  getCategorySubCataegory(){
    let requestData = {};
      requestData["action"] = 'OMS/api/operation.php/v1/requestForCallbackMdm';
      requestData["type"] = 'get';
      this.omsService.getRefundCategorySubCataegory(requestData).subscribe(
        (res) => {
            console.log(`getRefundCategorySubCataegory`, res);
        })
  }

  close()
  {
    this.modal.close();
  }

}
